<template>
  <el-dialog
    :title="`请选择${title}`"
    :close-on-click-modal="false"
    :visible.sync="show"
    :width="pda.status ? '90%' : '600px'">
    <label>{{`请选择: `}}</label>
    <el-select
      filterable 
      v-model="id" 
      :placeholder="`请选择`">
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <div class="d-flex right">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { getEquipment } from '@/api.js'
export default {
  name: 'CommonEquipmentList',
  data() {
    return {
      list: [],
      id: '',
      show: false
    }
  },
  computed: {
    ...mapGetters(['pda']),
    title() {
      if (this.type === 1) {
        return `清洗机`
      } else if (this.type === 2) {
        return `灭菌器`
      } else {
        return `设备`
      }
    }
  },
  props: {
    type: { // 清洗机、灭菌器或其他设备
      type: Number,
      default: 1,
      required: true
    }
  },
  methods: {
    open(id) {
      this.id = id || ''
      this.getList()
      this.show = true
    },
    getList() {
      // 获取列表
      const query = {
        type: this.type
      }

      return this.$request('get', getEquipment, query)
      .then(res => {
        if (res) {
          this.list = res
        }
      })
    },
    confirm() {
      if (!this.id) {
        this.$message.error(`不能为空`)
        
        return
      }

      this.$emit('confirm', this.id)
      this.cancel()
    },
    cancel() {
      this.show = false
    }
  }
}
</script>

<style>

</style>